  <template>
  <nav id="nav-footer-menu" style="z-index: 100;" v-if="getShowFooter">
    <ul class="footer-menu" :class="[getOS == 'ios' ? 'ios' : '']">
      <li>
        <router-link
          data-action="open_tab"
          data-eventcategory="app_flow"
          data-tab="home"
          :to="{ name: 'miniapp-home', params: { scroll: currentScroll }}"
          :class="[ this.$route.matched[1].name == 'miniapp-home' ? 'active' :'']"
        >
          <i class="fas fa-home"></i> HOME
        </router-link>
      </li>
      <li>
        <router-link
          data-action="open_tab"
          data-eventcategory="app_flow"
          data-tab="market"
          :to="{ name: 'miniapp-market', params: { scroll: currentScroll }}"
          :class="[ this.$route.matched[1].name == 'miniapp-market' || this.$route.matched[1].name == 'miniapp-fund-quote' || this.$route.matched[1].name == 'miniapp-stock-quote' || this.$route.matched[1].name == 'miniapp-indices-quote' ? 'active' :'']"
        >
          <i class="fas fa-briefcase"></i> Markets
        </router-link>
      </li>
      <li>
        <router-link
          data-action="open_tab"
          data-eventcategory="app_flow"
          data-tab="following"
          :to="{ name: 'miniapp-watch-list', params: { scroll: currentScroll}}"
          :class="[ this.$route.matched[1].name == 'miniapp-watch-list' ? 'active' :'']"
        >
          <i class="fas fa-star"></i> Watchlist
        </router-link>
      </li>
      <li>
        <router-link
          data-action="open_tab"
          data-eventcategory="app_flow"
          data-tab="search"
          :to="{ name: 'miniapp-search', params: { scroll: currentScroll }}"
          :class="[ this.$route.matched[1].name == 'miniapp-search' ? 'active' :'']"
        >
          <i class="far fa-search"></i> Search
        </router-link>
      </li>
      <li>
        <router-link
          data-action="open_tab"
          data-eventcategory="app_flow"
          data-tab="setting"
          :to="{ name: 'miniapp-setting', params: { scroll: currentScroll}}"
          :class="[ this.$route.matched[1].name == 'miniapp-setting' ? 'active' :'']"
        >
          <i class="fas fa-cog" ></i> Setting
        </router-link>
      </li>
    </ul>
  </nav>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      y: 0,
      currentScroll: 0
    };
  },
  computed: {
    ...mapGetters("global", ["getMarketActiveTab", "getShowFooter"]),
    getOS() {
      return this.$liff.getOS();
    }
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll() {
      this.currentScroll = window.scrollY;
    },
    open(url) {
      try {
        this.$liff.openWindow({
          url: url,
          external: false
        })
      } catch (err) {
        window.open(url)
      }
    },
  }
};
</script>
<style lang="scss" scoped>
#nav-footer-menu {
  .footer-menu {
    text-transform: uppercase;
    list-style: none;
    margin: 0;
    padding: 0;
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    border-top: 1px solid $color-line-grey;
    background-color: $color-white;
    z-index: 9;
    display: flex;
    li {
      flex: 1 1 auto;
      .external__link{
        cursor: pointer;
        display: inline;
        text-decoration: none;
        color: $color-light-grey-2;
        @extend %font-size-sss;
        display: block;
        padding: 8px;
        @include finRippleBtn($color-white, $color-white, $color-light-grey-2);
        text-align: center;
      }
      a {
        text-decoration: none;
        color: $color-light-grey-2;
        @extend %font-size-sss;
        width: 100%;
        display: block;
        padding: 8px;
        @include finRippleBtn($color-white, $color-white, $color-light-grey-2);
        text-align: center;
      }
      i {
        pointer-events: none;
        display: block;
        font-size: 14px;
      }
      img {
        width: 20px;
        display: block;
        margin: 0 auto;
      }
    }
    .active {
      color: $color-orange-finno;
    }
  }
  .ios {
    @include manageFooterMedia;
  }
}
</style>